import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import { isIE78 } from '../../../utils/utils';
import { rel } from '../../../utils/rel';

class VideoBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        const { content } = this.props;

        return (
            <div className={styles.video_box}>
                {content.map((item, index) => (
                    <a key={index} className={styles.video} href={item.url} target="_blank" rel={rel}>
                        <img src={item.thumbnail} alt="" />
                        <p className={styles.text}>
                            <span>{item.title}</span>
                        </p>
                        <span className={isIE78() ? styles.icon : styles.icon_2x} />
                    </a>
                ))}
            </div>
        );
    }
}

export default errorBoundary(VideoBox);
